const tokenKey = "rnd-token";
const roleKey = "role";
const liveAgentHashKey = "liveAgentHash";
const businessesKey = "businesses";
const currentBusinessKey = "currentBusiness";

export function getToken() {
  return localStorage.getItem(tokenKey);
}

export function setToken(token) {
  return localStorage.setItem(tokenKey, token);
}

export function removeToken() {
  return localStorage.removeItem(tokenKey);
}

export function getRole() {
  return localStorage.getItem(roleKey);
}

export function setRole(role) {
  return localStorage.setItem(roleKey, role);
}

export function removeRole() {
  return localStorage.removeItem(roleKey);
}

export function setLiveAgentHash(liveAgentHash) {
  return localStorage.setItem(liveAgentHashKey, liveAgentHash);
}

export function removeLiveAgentHash() {
  return localStorage.removeItem(liveAgentHashKey);
}

export function getBusinesses() {
  var businesses = localStorage.getItem(businessesKey);
  if (businesses != null) businesses = JSON.parse(businesses);
  return businesses;
}

export function setBusinesses(businesses) {
  if (businesses != null) businesses = JSON.stringify(businesses);
  return localStorage.setItem(businessesKey, businesses);
}

export function removeBusinesses() {
  return localStorage.removeItem(businessesKey);
}

export function getCurrentBusiness() {
  var business = localStorage.getItem(currentBusinessKey);
  if (business != null) {
    business = JSON.parse(business);
    return business.business;
  } else {
    return null; // admin
  }
}

export function getCurrentBusinessOuterObject() {
  var business = localStorage.getItem(currentBusinessKey);
  if (business != null) business = JSON.parse(business);
  return business;
}

export function setCurrentBusiness(currentBusiness) {
  if (currentBusiness != null)
    currentBusiness = JSON.stringify(currentBusiness);
  return localStorage.setItem(currentBusinessKey, currentBusiness);
}

export function removeCurrentBusiness() {
  return localStorage.removeItem(currentBusinessKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js